export const MERCHANT_FOUND = 'MERCHANT_FOUND';
export const MERCHANT_NOT_FOUND = 'MERCHANT_NOT_FOUND';
